import { defineStore } from 'pinia';
import { SubscribeState } from './types';

const useSubscribeStore = defineStore('subscribe', {
  state: (): SubscribeState => ({
    isConnected: false, // SSE是否连接
    pingTimer: undefined,
    UUID: '', // SSE连接的唯一值
    // 订阅了锁通知列表
    subscribeList: [],
  }),

  getters: {},

  actions: {
    // Set user's information
    setInfo(partial: Partial<SubscribeState>) {
      this.$patch(partial);
    },
    // Reset user's information
    resetInfo() {
      this.$reset();
    },
    // 记录SSE的连接状态
    setConnectStatus(status: boolean) {
      this.isConnected = status;
    },
    // 记录SSE连接的唯一值
    setUUID(uuid: string = '') {
      this.UUID = uuid;
      if (!uuid) this.setConnectStatus(false);
    },
    // 记录SSE推ping定时器
    setPingTimer(timerId?: number) {
      this.pingTimer = timerId;
    },
    // 更新订阅列表
    setSubscribeList(list: any[]) {
      this.subscribeList = list || [];
    },
    // 剔除订阅key
    removeSubscribeItems(removeList: any[]) {
      if (!Array.isArray(removeList)) return;
      this.setSubscribeList(
        this.subscribeList.filter((item: string) => !removeList.includes(item))
      );
    },
  },
});

export default useSubscribeStore;
